import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import isNaN from 'lodash/isNaN';

export const isDefined = <T>(value: T): boolean => !isNull(value) && !isUndefined(value) && !isNaN(value);
